export default class CustomError extends Error {
  constructor(error, messages) {
    super(error, messages);
    this.name = 'CustomError';
    this.code = error.code;
    this.status = error.status;
    this.path = error.path;
    this.message = messages;
  }
}
